import React from 'react';
import RegisterForm from './RegisterForm';

var getExternalProps = function getExternalProps() {
  var registerForm = document.getElementById('register-form');
  if (!registerForm || !registerForm.dataset || !registerForm.dataset.props) return {};

  try {
    return JSON.parse(registerForm.dataset.props);
  } catch (e) {
    return {};
  }
};

var RegisterFormRoot = function RegisterFormRoot() {
  var props = getExternalProps();
  return /*#__PURE__*/React.createElement(RegisterForm, props);
};

export default RegisterFormRoot;